import { Button } from "@progress/kendo-react-buttons";

export default function DangerZone({ onResetAll, t = {} }) {
  return (
    <div className="panel danger-panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.dangerZone || "Danger zone"}</p>
          <h3>{t.resetWorkspace || "Reset workspace"}</h3>
        </div>
      </div>
      <p className="muted paragraph">{t.dangerHint || "This removes all local expenses and goals for the signed-in user."}</p>
      <Button themeColor="error" fillMode="outline" icon="reset" onClick={onResetAll}>
        {t.resetLocalData || "Reset local data"}
      </Button>
    </div>
  );
}
